import React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { Divider, Grid, Link } from '@mui/material';
import { CampaignType, CampaignStatus } from '../../../../utils/enums'
import { format } from 'date-fns';

const FullDetails = ({ data }) => {
    return (
        <Accordion elevation={0} sx={{ borderRadius: '4px', '&:before': { height: '0px' } }}>
            <AccordionSummary
                expandIcon={<ArrowDropDownIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
                sx={{ margin: 0 }}>

                <h4>Details</h4>

            </AccordionSummary>
            <AccordionDetails
                sx={{ marginTop: '-17px' }}>
                <Divider />
                <Typography variant="h6" sx={{ marginBottom: 1, marginTop: 1 }}>Account Information</Typography>
                <Grid container spacing={2} sx={{ marginLeft: 2, marginRight: 2 }}>
                    {/* Left Column */}
                    <Grid item xs={6}>

                        <Grid container spacing={2}>
                            <Grid item xs={4}><Typography>Campaign Owner</Typography></Grid>
                            <Grid item xs={8}><Typography>{data?.ownerName || '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Campaign Name</Typography></Grid>
                            <Grid item xs={8}><Typography>{data?.campaignName || '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Start Date</Typography></Grid>
                            <Grid item xs={8}><Typography>{data?.startDate ? format(new Date(data.startDate), 'MMMM do yyyy, h:mm:ss a') : '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Expected Revenue</Typography></Grid>
                            <Grid item xs={8}><Typography>{data?.expectedRevenue || '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Actual Cost</Typography></Grid>
                            <Grid item xs={8}><Typography>{data?.actualCost || '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Numbers sent</Typography></Grid>
                            <Grid item xs={8}><Typography>{data?.numbersSent || '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Modified By</Typography></Grid>
                            <Grid item xs={8}><Typography>{data?.ownerName || '—'}<br />{data?.updatedAt ? format(new Date(data.updatedAt), 'MMMM do yyyy, h:mm:ss a') : '—'}</Typography></Grid>
                        </Grid>
                    </Grid>

                    {/* Right Column */}
                    <Grid item xs={6}>
                        <Grid container spacing={2}>
                            <Grid item xs={4}><Typography>Type</Typography></Grid>
                            <Grid item xs={8}><Typography>{CampaignType[data?.type]?.label ?? '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Status</Typography></Grid>
                            <Grid item xs={8}><Typography>{CampaignStatus[data?.status]?.label ?? '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>End Date</Typography></Grid>
                            <Grid item xs={8}><Typography>{data?.endDate ? format(new Date(data.endDate), 'MMMM do yyyy, h:mm:ss a') : '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Budgeted Cost</Typography></Grid>
                            <Grid item xs={8}><Typography>{data?.budgetedCost || '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Expected Response</Typography></Grid>
                            <Grid item xs={8}><Typography>{data?.expectedResponse || '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Created By</Typography></Grid>
                            <Grid item xs={8}><Typography>{data?.ownerName || '—'}<br />{data?.createdAt ? format(new Date(data.createdAt), 'MMMM do yyyy, h:mm:ss a') : '—'}</Typography></Grid>

                        </Grid>
                    </Grid>
                </Grid>
                <Typography variant="h6" sx={{ marginBottom: 1, marginTop: 1 }}>Description Information</Typography>
                <Grid container spacing={2} sx={{ marginLeft: 2, marginRight: 2 }}>
                    {/* Left Column */}
                    <Grid item xs={6}>
                        <Grid container spacing={2}>
                            <Grid item xs={4}><Typography>Description</Typography></Grid>
                            <Grid item xs={8}><Typography>{data?.description || '—'}</Typography></Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>
    )
}

export default FullDetails;